{
  "questions": {
    "culture": {
      "detailsPlaceholder": "",
      "label": "Do you have any cultural or family needs?",
      "nextLabel": "$t(common:next): <b>Dietary requirements</b>",
      "title": "<h3>Cultural or family needs</h3>"
    },
    "diet": {
      "detailsPlaceholder": "e.g. Vegetarian, vegan, halal, dairy free, gluten free",
      "label": "Do you have any special dietary requirements?",
      "nextLabel": "$t(common:next): <b>Other special needs or info</b>",
      "title": "<h3>Dietary requirements</h3>"
    },
    "language": {
      "de": "Deutsch / German",
      "detailsLabel": "What is your preferred language?",
      "fj": "Vosa Vakaviti / Fijian",
      "fr": "Français / French",
      "ja": "日本語 / Japanese",
      "ko": "한국어 / Korean",
      "label": "Do you have difficulty understanding English?",
      "mi": "Te Reo Māori",
      "ms": "Malay / Malaysian",
      "nextLabel": "$t(common:next): <b>Religious or spiritual needs</b>",
      "other": "Other",
      "pt": "Português / Portuguese",
      "sm": "Gagana Samoa / Samoan",
      "ta": "தமிழ் / Tamil",
      "title": "<h3>Understanding English</h3>",
      "tl": "Tagalog / Tagalog",
      "to": "Lea Faka-Tonga / Tongan",
      "zh": "简体中文 / Chinese"
    },
    "mobility": {
      "detailsPlaceholder": "e.g. Use walking frame or wheelchair; need help transferring to bed",
      "label": "Do you have a disability or need support with mobility?",
      "nextLabel": "$t(common:next): <b>Understanding English</b>",
      "title": "<h3>Mobility</h3>"
    },
    "other": {
      "detailsPlaceholder": "Only share what you feel is relevant. This helps us support you better.",
      "label": "Do you have any other special needs, or is there any other information you would like us to know about?",
      "nextLabel": "$t(common:next): <b>Getting your bowel prep</b>",
      "title": "<h3>Other special needs or information</h3>"
    },
    "prep": {
      "label": "Please choose how you’d like to receive it:",
      "nextLabel": "$t(common:next): <b>Complete booking</b>",
      "pick-up-from-hospital": "<label>Pick up from {{company}}</label><p>Collect your prep pack from reception during opening hours.</p>",
      "pick-up-from-local-pharmacy": "<label>Pick up from your local pharmacy</label><p>We’ll email you a prescription to take to your pharmacy.</p>",
      "receive-by-mail": "<label>Receive by mail</label><p>We’ll post your prep pack to the home address you gave us if your procedure is booked more than a week out.</p>",
      "text": "To prepare for your procedure, you’ll need to take special medication that clears your bowel.",
      "title": "<h3>Getting your bowel prep</h3><p>To prepare for your procedure, you’ll need to take special medication that clears your bowel.</p>"
    },
    "religion": {
      "detailsPlaceholder": "e.g. Quiet space for prayer, prefer same-gender staff for personal care",
      "label": "Do you have any religious or spiritual needs?",
      "nextLabel": "$t(common:next): <b>Cultural or family needs</b>",
      "title": "<h3>Religious or spiritual needs</h3>"
    }
  }
}
